import { useState, useMemo } from 'react';
import { isEqual } from 'lodash';
import { useBriefCreationContext } from '../../context/BriefCreationContext';

export const useDiscardChanges = () => {
  const { brief } = useBriefCreationContext();

  const [initialSections] = useState(() =>
    brief?.sections?.map(({ id, content, included, attachments }) => ({
      id,
      content,
      included,
      attachments: attachments?.map((a) => a.id),
    }))
  );

  const hasBriefChanged = useMemo(() => {
    const currentSections = brief?.sections?.map(({ id, content, included, attachments }) => ({
      id,
      content,
      included,
      attachments: attachments?.map((a) => a.id),
    }));

    return !isEqual(currentSections, initialSections);
  }, [brief?.sections, initialSections]);

  return { hasBriefChanged };
};
